<div class="ac-page c7-access-view c7-access-change-password">

  <header class="ac-topbar">
    <div class="ac-topbar__inner">
      <a class="ac-brand" href="javascript:void(0)" aria-label="CULTURA">
        <img src="assets/logo-blue.png" alt="CULTURA" class="ac-brand__logo" />
      </a>
      <label class="ac-lang">
        <span>{{ "acceptPage.language" | translate }}</span>
        <select [value]="selectedLanguage" (change)="changeLanguage($any($event.target).value)">
          <option *ngFor="let language of supportedLanguages" [value]="language.code">{{ language.name }}</option>
        </select>
      </label>
    </div>
  </header>

  <main class="ac-main ac-main--center">
    <section class="ac-card ac-card--single" aria-labelledby="ac-title">
      <div class="ac-card__head">
        <h2 id="ac-title">{{ "resetPassword.callback.submit" | translate }}</h2>
        <p class="ac-card__sub">{{ "authPages.resetIntro" | translate }}</p>
      </div>

      <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()" novalidate class="ac-form">
        <div class="ac-field">
          <label for="ac-password">{{ "resetPassword.callback.password" | translate }}</label>
          <div class="ac-input-wrap">
            <input id="ac-password" [type]="newPassword ? 'text' : 'password'" formControlName="password" autocomplete="new-password"
              [attr.aria-invalid]="(submitted || f['password'].touched) && f['password'].invalid ? 'true' : 'false'" />
            <button type="button" class="ac-toggle" (click)="newPasswordVisibility()"
              [attr.aria-label]="(newPassword ? 'acceptPage.hidePassword' : 'acceptPage.showPassword') | translate">
              <img [src]="newPassword ? 'assets/eye-slash.svg' : 'assets/eye.svg'" alt="" />
            </button>
          </div>
          <span class="ac-error" *ngIf="(submitted || f['password'].touched) && f['password'].hasError('required')" aria-live="polite">{{ "acceptform.form.pass.error.required" | translate }}</span>
          <span class="ac-error" *ngIf="(submitted || f['password'].touched) && f['password'].hasError('minlength')" aria-live="polite">{{ "authPages.minLength" | translate: { min: minLength } }}</span>
          <app-password-rules [password]="changePasswordForm.value.password || ''"></app-password-rules>
        </div>
        <div class="ac-field">
          <label for="ac-repeat">{{ "resetPassword.callback.passwordRepeat" | translate }}</label>
          <div class="ac-input-wrap">
            <input id="ac-repeat" [type]="confirmPassword ? 'text' : 'password'" formControlName="new_password" autocomplete="new-password"
              [attr.aria-invalid]="(submitted || f['new_password'].touched) && f['new_password'].invalid ? 'true' : 'false'" />
            <button type="button" class="ac-toggle" (click)="confirmPasswordVisibility()"
              [attr.aria-label]="(confirmPassword ? 'acceptPage.hidePassword' : 'acceptPage.showPassword') | translate">
              <img [src]="confirmPassword ? 'assets/eye-slash.svg' : 'assets/eye.svg'" alt="" />
            </button>
          </div>
          <span class="ac-error" *ngIf="(submitted || f['new_password'].touched) && f['new_password'].hasError('required')" aria-live="polite">{{ "acceptform.form.repeatpass.error.required" | translate }}</span>
          <span class="ac-error" *ngIf="(submitted || f['new_password'].touched) && f['new_password'].hasError('confirmPasswordValidator')" aria-live="polite">{{ "authPages.mismatch" | translate }}</span>
        </div>

        <button class="ac-btn" type="submit">{{ "resetPassword.callback.submit" | translate }}</button>
        <p class="ac-error ac-error--block" *ngFor="let msg of serverErrors" role="alert">{{ msg }}</p>
        <p class="ac-error ac-error--block" *ngIf="errormsg" role="alert">{{ errormsg | translate }}</p>
      </form>

      <hr class="ac-card__divider" />
      <p class="ac-card__alt"><a [routerLink]="['/login']">{{ "authPages.backToLogin" | translate }}</a></p>
    </section>
  </main>

  <app-auth-footer></app-auth-footer>
</div>
